import { ApiResponse } from "../../../../../types";
import { apiClient } from "../../../../../api/client";
import {
  IndriveCheckoutItem,
  ConfirmCheckoutParams,
  StartDocParams,
  SubmitRemessaParams,
  IndrivePushParams,
} from "../types";

export const indriveCheckoutService = {
  async getCheckoutList(params: {
    dbName: string;
    ops: string;
  }): Promise<ApiResponse<IndriveCheckoutItem[]>> {
    return apiClient.post("/gestorCheckoutList", params);
  },

  async confirmCheckout(
    params: ConfirmCheckoutParams
  ): Promise<ApiResponse<void>> {
    return apiClient.post("/gestorConfirmCheckout", params);
  },

  async startDoc(params: StartDocParams): Promise<ApiResponse<void>> {
    return apiClient.post("/gestorDocStart", params);
  },

  async submitRemessa(
    params: SubmitRemessaParams
  ): Promise<ApiResponse<void>> {
    return apiClient.post("/gestorSubmitRemessaDb", params);
  },

  async pushIndrive(params: IndrivePushParams): Promise<ApiResponse<void>> {
    return apiClient.post("/gestorIndrivePush", params);
  },
};
